<!-- 了解更多 -->
<template>
  <div style="height: 100%;">
    <Header></Header>
    <div class="knowmore">
      <span class="fb tl f20 pt20 mL20" style='display: inline-block'>多了解你一些</span>
      <span class='pt20 mr20 f16' style='display: inline-block; float: right'> {{ this.currentIndex+1 }}/5步</span>
      <div style="width: 625px;margin:85px auto" v-for="(item, index) in questions" :key="index" v-show="item.show">
        <p class="f20 fb">{{item.name}}：</p>
        <div class="f18 pL10 qDiv" :class="item.multi ? 'multiDiv' : 'simpleDiv'">{{item.ques}}</div>
        <div class="btns" v-if="item.options.length !== 0">
          <el-tooltip v-for="(item1, index) in item.options"
                      :key='index'
                      placement='bottom' effect='light'
                      :disabled="item.tooltip[index] === ''" :content=item.tooltip[index]>
            <el-button
              :class="getBtnClass(item.optionLength, index, item1)"
              @click="selected(item, item1)"
            >
              {{item1}}
            </el-button>
          </el-tooltip>
        </div>
        <div class="ques5" v-else>我想在 <el-input v-model="year"></el-input>年后，存够 <el-input v-model="money"></el-input>元</div>
        <div class="tr" style="width:670px;margin: 60px auto;">
          <el-button v-if="item.name !== '问题一'" class="co-f mt20" type='info' style="height: 30px;line-height: 0; float: left;" @click="goBack">上一步</el-button>
          <el-button v-if="item.name === '问题五'" class="co-f mt20 base-bg base-border-color" style="height: 30px;line-height: 0;" @click="toResult">下一步</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      year: 0,
      money: 0,
      account: '',
      password: '',
      beforeTax: '',
      spending: '',
      currentIndex: 0,
      questions: [
        { name: '问题一',
          ques: '您认为您对于投资的偏好是什么？',
          options: ['保守', '中性', '激进'],
          tooltip: ['', '', ''],
          show: true, multi: false, optionLength: 3 ,key: 'ANSWER1'},
        { name: '问题二',
          ques: '您的投资经验有多少年？',
          options: ['1-3年', '5-10年', '10年以上'],
          tooltip: ['', '', ''],
          show: false, multi: false, optionLength: 3, key: 'ANSWER2' },
        {
          name: '问题三',
          ques: '如果现有两个投资产品，一个投资产品有100%的机会可以获得3%的收益，另外一个产品有50%的机会获得15%的收益，50%的机会获得-5%的收益，您会选择哪一个？',
          options: ['第一个投资产品', '第二个投资产品'],
          tooltip: ['', ''],
          show: false,
          multi: true,
          optionLength: 2,
          key: 'ANSWER3',
        },
        { name: '问题四',
          ques: '您需要的退休生活水平是怎么样的？',
          options: ['基础', '舒适', '富足', '奢侈'],
          tooltip: [
            '期望退休后养老金达到约55%的退休前工资水平',
            '期望退休后养老金达到约70%的退休前工资水平',
            '期望退休后养老金达到约90%的退休前工资水平',
            '期望退休后养老金达到约110%的退休前工资水平'],
          show: false, multi: false, optionLength: 4 ,key: 'ANSWER4'},
        { name: '问题五',
          ques: '您想在X年后，存够多少钱？',
          options: [],
          tooltip: [],
          show: false, multi: false, optionLength: 0, key: 'ANSWER5'},
      ],
      selectedOptions : {}
    }
  },
  components: { Header },
  mounted () {
    if (!this.$route.params ||
      !this.$route.params.age ||
      // !this.$route.params.alreadyScaleSaving ||
      // !this.$route.params.estimatedExpenses ||
      // !this.$route.params.preTaxIncome ||
      // !this.$route.params.otherIncome ||
      !this.$route.params.gender) {
      this.$router.push({name: 'KnowYou'})
    }
  },
  methods: {
    getBtnClass (length, index, option) {
      let key = this.questions[this.currentIndex]['key']
      let clsStr = 'input_btn '
      if (this.selectedOptions[key] === option) {
        clsStr = 'input_btn_selected '
      }
      if (length === 2) {
        if (index !== 1) {
          return clsStr + "two-button"
        } else {
          return clsStr + "two-button-tail"
        }
      } else if (length === 3) {
        if (index !== 2) {
          return clsStr + "third-button"
        } else {
          return clsStr + "third-button-tail"
        }
      } else {
        if (index !== 3) {
          return clsStr + "fourth-button"
        } else {
          return clsStr + "fourth-button-tail"
        }
      }
    },
    goBack () {
      this.questions[this.currentIndex]['show'] = false
      this.currentIndex -= 1
      this.questions[this.currentIndex]['show'] = true
    },
    toResult () {
      const baseInfo = {
        'age': this.$route.params.age,
        'gender': this.$route.params.gender,
        // 'alreadyScaleSaving': this.$route.params.alreadyScaleSaving,
        // 'preTaxIncome': this.$route.params.preTaxIncome,
        // 'otherIncome': this.$route.params.otherIncome,
        // 'estimatedExpenses': this.$route.params.estimatedExpenses,
        'answerMoney': this.money,
        'answerYear': this.year,
        ...this.selectedOptions
      }
      this.$router.push({name: 'ResultNew', params:baseInfo})
    },
    selected (item, option) {
      this.selectedOptions[item.key] = option
      item.show = false
      this.currentIndex += 1
      this.questions[this.currentIndex]['show'] = true
    }
   }
}
</script>

<style scoped>
.knowmore{
   width: 1130px;
   height: 593px;
   border-radius: 20px;
   background: #fff;
   margin: 120px auto;
}
.knowmore .qDiv{
  width: 625px;
  height: 120px;
  border-radius: 15px;
  border: 1px solid rgba(187,187,187);
  margin-top: 57px;
}
.simpleDiv{
  line-height: 120px;
}
.multiDiv{
  line-height: 38px;
}
.knowmore .btns{
  width: 625px;
  height: 30px;
  margin-top: 57px;
}
.btns .el-button{
  margin-left: 0;
  height: 30px;
  line-height: 0;
}
.two-button{
  width: 302px;
  margin-right: 20px;
}
.two-button-tail{
  width: 302px;

}
.third-button{
  width: 194px;
  margin-right: 20px;
}
.third-button-tail{
  width: 194px;

}
.fourth-button{
  width: 141px;
  margin-right: 20px;
}
.fourth-button-tail{
  width: 141px;
}
.ques5{
  margin-top: 57px;
}
.ques5 .el-input{
  width: 200px;
  height: 30px;
  margin: 0 10px;
}
.el-input >>> .el-input__inner{
  height: 28px;
}
.input_btn {
  border-color: #e90a5b;
  background: #e90a5b;
  color: #fff;
}
.input_btn_selected {
  /*border-color: #fff;*/
  background: #fff;
  color: #e90a5b;
}
</style>



// WEBPACK FOOTER //
// src/components/KnowMore.vue